import {ToolRenderer} from '../tool/Tool'
import {pairedToolCallToToolMetadata, pairedToolCallToToolProps} from '../../../utils/events/tool-helpers'
import type {ToolCallItem} from '../../../types/events'

export function ToolCall({
  item,
  isInGroup,
  isEditGroup,
  mcpToolNameMappings,
}: {
  item: ToolCallItem
  isInGroup?: boolean
  isEditGroup?: boolean
  mcpToolNameMappings?: Record<string, string>
}) {
  const {name, args, delta, detailedContent, isMcpTool, executionState} = pairedToolCallToToolProps(item.toolCall)
  const metadata = pairedToolCallToToolMetadata(item.toolCall)
  return (
    <ToolRenderer
      name={name}
      delta={delta}
      args={args}
      detailedContent={detailedContent}
      isMcpTool={isMcpTool}
      executionState={executionState}
      metadata={metadata}
      isInGroup={isInGroup}
      isEditGroup={isEditGroup}
      mcpToolNameMappings={mcpToolNameMappings}
    />
  )
}
